import LoadTextsPlugin from './LoadTextsPlugin';
import contentItemsStore from '../apps/_shared/store/contentItems';
import textsStore from '../apps/_shared/store/texts';
import axios from 'axios';

const connectCyclesWithCourses = (cycles = [], courses = []) => {
  courses.forEach(
    (course) =>
      (course.cycles = cycles.filter((cycle) => cycle.courseId === course._id))
  );
};

const store = {
  plugins: [LoadTextsPlugin],
  state: {
    // old content items - "texts"
    courses: void 0,
    cycles: void 0,
    ...contentItemsStore.state,
    ...textsStore.state,
  },
  mutations: {
    SET_COURSES(state, courses) {
      state.courses = courses;
      connectCyclesWithCourses(state.cycles, state.courses);
    },
    SET_CYCLES(state, cycles) {
      state.cycles = cycles;
      connectCyclesWithCourses(state.cycles, state.courses);
    },
    ...contentItemsStore.mutations,
    ...textsStore.mutations,
  },
  actions: {
    loadCourses({ commit, state }, { with: w }: { with?: string[] } = {}) {
      if (state.courses) {
        return Promise.resolve();
      }

      return axios
        .get('/api/courses/', { params: { ...(w && { with: w.join(',') }) } })
        .then(({ data }) => {
          commit('SET_COURSES', data);
        })
        .catch((ignore) => commit('ADD_ERROR_MESSAGE', 'COURSES_NOT_LOADED'));
    },
    loadCycles({ commit, state }, { force }: { force?: boolean } = {}) {
      if (!force && state.cycles) {
        return Promise.resolve();
      }

      return axios
        .get('/api/cycles/', {})
        .then(({ data }) => {
          commit('SET_CYCLES', data.cycles);
        })
        .catch((ignore) => commit('ADD_ERROR_MESSAGE', 'CYCLES_NOT_LOADED'));
    },
    ...contentItemsStore.actions,
    ...textsStore.actions,
  },
};

export default store;
